import React from "react"

import Text from "../../../../../_components/Text"
import Button from "../../../../../_components/Button"
import Checkbox from "../../../../../_components/Checkbox"
import LoadingInput from "../../../../../_components/LoadingInput"
import Address from "../../../../../_components/Address"
import styled, { css } from "styled-components"

import * as colors from "../../../../../assets/_base/colors/"
import { createBranch } from "../../../../../api/branches"
import BranchType from "./components/BranchType"
import Individual from "./components/Individual"
import Company from "./components/Company"
import { toast as toastify } from "react-toastify"

const StepContainer = styled.div`
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  margin-top: 20px
`

const StepNumber = styled.div`
  cursor: pointer
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  font-size: 0.9em
  width: 50px
  height: 50px
  border-radius: 50%
  background-color: ${colors.secondary}
  * {
    color: white
  }
  ${(props) => {
    if (props.current) {
      return css`
        background-color: ${colors.primary}
      `
    }
  }}
`

const StepText = styled.div`
  display: flex
  justify-content: center
  align-items: center
`

export default (props) => {
  const [loading, setLoading] = React.useState(false)

  const [step, setStep] = React.useState("type")

  const [data, setData] = React.useState({
    type: 1,
    step: "data",
  })

  const [errors, setErrors] = React.useState({})

  const nextStep = () => {
    if (step === "type") {
      setStep("data")
    } else if (step === "data") {
      setStep("address")
    }
  }

  const previousStep = () => {
    if (step === "address") {
      setStep("data")
    } else if (step === "data") {
      setStep("type")
    }
  }

  const onChange = (e) => {
    let { name, value } = e
    let tempData = { ...data }

    if (name.includes(":")) {
      const [key, child] = name.split(":")

      if (!tempData[key]) {
        tempData[key] = {}
      }

      if (
        child === "cpf" ||
        child === "cnpj" ||
        child === "fancy_name" ||
        child === "main_cnae" ||
        child === "phone_number"
      ) {
        value = value.replace(/[^a-zA-Z0-9]/g, "")
      }

      tempData[key][child] = value
    } else {
      value = value.replace(/[^a-zA-Z0-9@.]/g, "")
      tempData[name] = value
    }

    setData(tempData)

    setErrors((old) => {
      const newErrors = { ...old }
      delete newErrors[name]
      if (name === "company:fancy_name") {
        delete newErrors["company.fancy_name"]
      }
      if (name === "company:cnpj") {
        delete newErrors["company.cnpj"]
      }
      return newErrors
    })
  }

  const handleReceiveAddress = (address) => {
    setData({ ...data, address })
    // setErrors((old) => {
    //   const newErr = { ...old }
    //   delete newErr.address
    //   return newErr
    // })
  }


  const handleCreateErrors = () => {
    let newErrors = {}

    if (
      (data.type === 1 && data.step === "data") || (data.type === 4 && data.step === "data")) {

      const indiviudal = data.individual || {}


      if
        (!data.name) {
        newErrors.name = "Preencha um nome válido."
      }
      if (!data.email) {
        newErrors.email = "Preencha um e-mail válido."
      }
      if (!data.phone_number) {
        newErrors.phone_number = "Preencha um número de telefone válido."
      }
      if (!indiviudal.cpf) {
        newErrors["individual:cpf"] = "Preencha um nome CPF válido."
      }

    }

    if (
      (data.type === 2 && data.step === "data") || (data.type === 3 && data.step === "data")
    ) {
      // Evita erro se company não existir
      const company = data.company || {}

      if (!data.name) {
        newErrors.name = "Preencha um nome válido."
      }
      if (!data.email) {
        newErrors.email = "Preencha um e-mail válido."
      }
      if (!data.phone_number) {
        newErrors.phone_number = "Preencha um número de telefone válido."
      }

      if (!company.fancy_name) {
        newErrors["company:fancy_name"] = "Preencha um nome fantasia válido."
      }
      if (!company.cnpj) {
        newErrors["company:cnpj"] = "Preencha um CNPJ válido."
      }

    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleCreateBranch = () => {
    const isValid = handleCreateErrors()
    if (!isValid) {
      return
    }

    let payload = { ...data }

    if ([1, 4].includes(parseInt(data.type))) {
      payload.branch = {
        name: data.name,
        aliquota_credito: 0,
        is_fiscal: false,
        branch_type: data.type,
        main_company: true,
      }
    }

    if ([2, 3].includes(parseInt(data.type))) {
      payload.branch = {
        aliquota_credito: 1,
        is_fiscal: false,
        branch_type: data.type,
        crt: data.crt,
        crt_description: data.crt_description,
        main_company: true,
      }
    }

    createBranch(payload)
      .then((response) => {
        toastify.success("Filial criada com sucesso.", { position: "top-center" })
        setTimeout(() => {
          window.location.href = '/settings/branch'
        }, 1000)
        
      })
      .catch((error) => {

        if (error.non_field_errors) {
          setErrors((old) => ({
            ...old,
            form: "Preencha todas as informações necessárias.",
          }))
        }

        if (error.address) {
          setErrors((old) => ({
            ...old,
            address: "Preencha o endereço corretamente.",
          }))
        }

        if (error.email) {

          toastify.error("Preencha um endereço de e-mail válido.", { position: "top-center" })
        }

      })
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-4">
          <StepContainer onClick={() => setStep("type")}>
            <StepNumber current={step === "type"}>
              <Text fontSize="md" color="white">
                1
              </Text>
            </StepNumber>
            <StepText>
              <Text fontSize="md">Escolha o tipo</Text>
            </StepText>
          </StepContainer>
        </div>
        <div className="col-4">
          <StepContainer onClick={() => setStep("data")}>
            <StepNumber current={step === "data"}>
              <Text fontSize="md" color="white">
                2
              </Text>
            </StepNumber>
            <StepText>
              <Text fontSize="md">Informações</Text>
            </StepText>
          </StepContainer>
        </div>
        <div className="col-4">
          <StepContainer onClick={() => setStep("address")}>
            <StepNumber current={step === "address"}>
              <Text fontSize="md" color="white">
                3
              </Text>
            </StepNumber>
            <StepText>
              <Text fontSize="md">Endereço</Text>
            </StepText>
          </StepContainer>
        </div>
      </div>

      <div className="row">
        <hr style={{ width: "100%" }} />
      </div>

      <BranchType
        onChange={(value) => {
          setData({ ...data, type: value })
        }}
        step={step}
        type={data.type}
      />

      <div
        className={
          step === "data" && (data.type === 1 || data.type === 4)
            ? ""
            : "d-none"
        }
      >

        <Individual componenType={data.type} onChange={onChange} data={data} errors={errors} />
      </div>

      <div
        className={
          step === "data" && (data.type === 2 || data.type === 3) ? "" : "d-none"}
      >
        <Company onChange={onChange} data={data} errors={errors} />
      </div>

      <div className={step === "address" ? "" : "d-none"}>
        <Address viacep loading={true} onChange={handleReceiveAddress} />
        {errors.address && (
          <div className="text-danger mt-2">{errors.address}</div>
        )}
      </div>

      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between">
            <Button onClick={previousStep}>Voltar</Button>
            <Button onClick={nextStep}>Avançar</Button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-center">
            <Button onClick={handleCreateBranch}>Salvar</Button>
          </div>
        </div>
      </div>

      {errors.form && (
        <div className="row">
          <div className="col-12 text-center text-danger mt-2">{errors.form}</div>
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Branch/Create/index.jsx